export default async function termsAndConditions(apiKey, quoteId) {
  const response = await fetch(`https://services.codeweavers.net/api/finance/quote/${quoteId}/termsandconditions`, {
    headers: {
      'X-CW-ApiKey': apiKey,
    },
  });

  const terms = (await response.json()).TermsAndConditions;

  return terms;
}
